module.exports = __webpack_public_path__ + "media/images/t-versa-square-b9fa74476366f21cf6e3e051ea1acce2.png";